import type { Category } from 'src/types';
import type { ClientMarket } from 'config/types/client-market';

const ENABLED_MARKET = 'se';

const CATEGORY_WHITE_LIST = [
  '1944',
  '148',
  '1827',
  '707',
  '1594',
  '401',
  '2621',
  '1349',
  '1351',
  '767',
  '769',
  '770',
  '1987',
  '2062',
  '1915',
  '2251',
  '3273',
  '2222',
  '2040',
  '551',
  '1110',
  '1918',
  '2027',
  '3215',
  '2086',
  '3172',
  '1153',
  '1166',
  '1327',
  '1326',
  '1325',
  '1152',
  '2019',
  '3187',
  '2020',
  '2021',
  '103',
  '879',
  '1808',
  '1792',
  '2668',
  '2741',
  '1973',
  '2760',
  '2395',
  '2047',
  '2772',
  '2774',
  '917',
  '3582',
  '3437',
  '3439',
  '2401',
  '1155',
  '2064',
  '1672',
  '1726',
];

export const isWhitelistedForColors = (
  market: ClientMarket,
  category?: Category | null
) => {
  if (market.code !== ENABLED_MARKET) {
    return false;
  }
  return Boolean(
    category?.path?.length &&
      category?.path?.some(categoryPath =>
        CATEGORY_WHITE_LIST.includes(categoryPath.id)
      )
  );
};
